export default __webpack_public_path__ + "static/media/71.9cb3487e.jpeg";